<template>
  <v-dialog v-model="value" width="600" persistent>
    <v-card class="w-100 rounded-lg pa-4">
      <v-card-title class="px-0">{{ $t('tslContractors.import') }}</v-card-title>
      <v-card-text class="px-0">
        <v-file-input
          v-model="selectedFile"
          :label="$t('tslContractors.selectFile')"
          accept=".xlsx"
          outlined
          dense
          show-size
          :disabled="importing"
        />

        <v-alert
          v-if="importResult"
          :type="importResult.errorCount > 0 ? 'warning' : 'success'"
          dense
          outlined
          class="mt-4 text-body-2"
        >
          {{ $t('tslContractors.importResult', {
            success: importResult.successCount,
            errors: importResult.errorCount
          }) }}
        </v-alert>
      </v-card-text>
      <v-card-actions class="d-flex px-0 pt-2">
        <v-btn outlined @click="close()" :disabled="importing">
          {{ $t('common.close') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="downloadTemplate"
          :loading="templateLoading"
          class="mr-2"
          depressed
        >
          {{ $t('tslContractors.downloadTemplate') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="importFile"
          :disabled="!selectedFile || importing"
          :loading="importing"
          depressed
        >
          {{ $t('tslContractors.importFile') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'
import { downloadFile } from '@/utils/helpers'

export default {
  name: 'TSLImportDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      selectedFile: null,
      importing: false,
      templateLoading: false,
      importResult: null
    }
  },
  methods: {
    close () {
      this.selectedFile = null
      this.importResult = null
      this.$emit('input', false)
    },
    async downloadTemplate () {
      this.templateLoading = true
      try {
        const response = await Service.getFile('/TSLContractor/GetImportTemplate')
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        downloadFile({ name: 'szablon_importu_kontrahentow_tsl.xlsx' }, blob)
      } catch (e) {
        await this.$store.dispatch('setErrorNotification', this.$t('tslContractors.templateDownloadError'))
      } finally {
        this.templateLoading = false
      }
    },
    async importFile () {
      if (!this.selectedFile) return

      this.importing = true
      this.importResult = null

      try {
        const formData = new FormData()
        formData.append('file', this.selectedFile)

        const { data } = await Service.post('/TSLContractor/ImportContractors', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        this.importResult = data

        if (data.successCount > 0) {
          this.$emit('imported')
        }
      } catch (e) {
        await this.$store.dispatch('setErrorNotification', this.$t('tslContractors.importError'))
      } finally {
        this.importing = false
      }
    }
  }
}
</script>
